$(document).ready(function() {

    setTimeout(function() {
        // Huber Logo ausblenden
        $('a[href$="http://www.hubermedia.de"] img').hide();
        $('#mapInner a[href$="http://www.hubermedia.de"] img').hide();
    }, 1000);

    /****************** SPRACHWECHSLER **********************/

    if ($("#langNavigation").length > 0) {

        var czURL = "<li><a href='https://www.regiondunaj.cz'><span class='flag-icon flag-icon-cz' aria-hidden='true'></span><span class='text' lang='cs'>Cesky</span></a></li>";
        $(".langNavigation ul").append(czURL);

        var itURL = "<li><a href='https://www.regionedanubio.it'><span class='flag-icon flag-icon-it' aria-hidden='true'></span><span class='text' lang='it'>Italiano</span></a></li>";
        $(".langNavigation ul").append(itURL);

        var nlURL = "<li><a href='https://www.donauregio.nl/nl'><span class='flag-icon flag-icon-nl' aria-hidden='true'></span><span class='text' lang='nl'>Nederlands</span></a></li>";
        $(".langNavigation ul").append(nlURL);

    }

});

$(window).resize(function() {
    setTimeout(function() {
        // Huber Logo ausblenden.
        $('a[href$="http://www.hubermedia.de"] img').hide();
    }, 1000);
});